import { request } from "../../../utils/promises/library";

import { HTTP_OK } from "../../../constants/http";
import { HttpError } from "../../../utils/errors/http";

import { getString } from "config-api";

const broadcast_schedule_url = getString("Client.scheduleApi.sportsBaseURL");

export const fetch_broadcast_schedule = () => {
    return request(broadcast_schedule_url).then((res) => {
        if (res.status === HTTP_OK) {
            return res.json();
        }
        throw new HttpError(res.status, res.statusText);
    });
};
